import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import PageContainer from "./PageContainer";

export default function AppLayout({
  children,
  showAdminLink = false,
  accessLabel = "",
  fluid = false,
}) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="h-screen overflow-hidden bg-[#F5F7FB] text-slate-950">
      <div className="flex h-screen overflow-hidden">
        <Sidebar
          showAdminLink={showAdminLink}
          mobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
        />

        <div className="flex min-w-0 flex-1 flex-col overflow-hidden bg-[#F5F7FB]">
          <Topbar
            accessLabel={accessLabel}
            onOpenSidebar={() => setMobileSidebarOpen(true)}
          />

          <main className="min-h-0 flex-1 overflow-y-auto">
            {fluid ? children : <PageContainer>{children}</PageContainer>}
          </main>
        </div>
      </div>
    </div>
  );
}